import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {
  AnalysisInputs,
  MethodAnalysisSources,
  WorksheetAnalysisSources,
} from 'procedures/design/ProcedureMethodAnalysisTypes';
import {getJSONPromise} from 'util/Net';

/**
 * Backfills fields the server may not have sent yet -- getJSONPromise doesn't validate the response
 * against our types, so a server predating a given field (e.g. mid-deploy, running old code) sends a
 * response simply missing it rather than an empty array/null, unlike our types which mark it required.
 */
function withAnalysisInputsDefaults<T extends {analysisInputs: AnalysisInputs}>(
  sourcesPerStep: Array<T>
): Array<T> {
  return sourcesPerStep.map((source) => ({
    ...source,
    analysisInputs: {
      ...source.analysisInputs,
      scratchPlates: source.analysisInputs.scratchPlates ?? [],
    },
  }));
}

export async function fetchWorksheetAnalysisSources(worksheetId: string): Promise<WorksheetAnalysisSources> {
  const result: WorksheetAnalysisSources = await getJSONPromise(
    `${getApiBaseForObjectType(DomainGraphType.PROCEDURE)}/${worksheetId}/analysis-sources`
  );
  return {
    ...result,
    sourcesPerStep: withAnalysisInputsDefaults(result.sourcesPerStep),
  };
}

export async function fetchProcedureMethodDefinitionAnalysisSources(
  pmdvId: string
): Promise<MethodAnalysisSources> {
  const result: MethodAnalysisSources = await getJSONPromise(
    `${getApiBaseForObjectType(DomainGraphType.PROCEDURE)}/${pmdvId}/method-definition-analysis-sources`
  );
  return {
    ...result,
    sourcesPerStep: withAnalysisInputsDefaults(result.sourcesPerStep),
  };
}
